module.exports = __webpack_public_path__ + "static/media/default-building.906269a5.svg";